type Validatable = string | number | null | undefined;

const validator = {
  isInteger: (value: string | number): boolean => {
    const num = Number(value);
    return !Number.isNaN(num) && Number.isInteger(num);
  },
  isPositiveNumber: (value: string | number, allowZero = false): boolean => {
    const num = Number(value);
    if (Number.isNaN(num)) return false;
    return allowZero ? num >= 0 : num > 0;
  },
  isPositiveInteger: (value: Validatable): boolean => {
    if (value == null) return false;
    if (typeof value === "string" && value.trim() !== value) return false;
    const num = Number(value);
    return Number.isInteger(num) && num > 0;
  },
};
export default validator;
